export const PAGE_SIZE_FOR_ADD_EDIT = 15;
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE = 0;
export const MAX_PAGE_SIZE = 100000;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const PAGE_SIZE_FOR_NEW_PRACTICAL_ATTR = 10;

export const PAGE_SIZE_FOR_NEW_PRACTICAL_TASK = 5;

export const TableSearchDebounceTime = 500;

export const MyProfile_MyJob_ShowTasks_LocalStorageKey = 'profile-job-competencies-show-task';

export const TEAM_LIST_VIEW_MODE = 'TEAM_LIST_VIEW_MODE';

// Marks that platform:entered has already fired this browser session (per tab).
export const PLATFORM_ENTERED_KEY = 'ph_platform_entered';

// Marks that the benchmark "select gaps to add as skills" hint has been dismissed. Kept in
// localStorage (survives reload/tab close) and cleared on login/logout + token-expiry re-auth so
// the hint reappears once per login session.
export const BENCHMARK_GAP_HINT_DISMISSED = 'benchmark_gap_hint_dismissed';

export const PARTICIPANT_MARKING = {
  None: {
    value: 0,
    label: 'Not assessed',
  },
  Pass: {
    value: 1,
    label: 'Satisfactory',
  },
  Failed: {
    value: 2,
    label: 'Not yet satisfactory',
  },
};

export const IN_PROGRESS = 'In progress';
export const PENDING_CONFIRMATION = 'Pending confirmation';
export const COMPLETED = 'Completed';

export const PRACTICAL_STATUS = {
  0: {
    value: 0,
    label: 'In progress',
  },
  1: {
    value: 1,
    label: 'Pending confirmation',
  },
  2: {
    value: 2,
    label: 'Completed',
  },
  3: {
    value: 3,
    label: 'Scheduled',
  },
};

export const PRACTICAL_TYPE = {
  NONE: 0,
  INSTRUCTOR: 1,
  PARTICIPANT: 2,
  BOTH: 3,
};

export const INTEGRATION_STATUS = {
  ACTIVE: 1,
  PAUSE: 2,
  ISSUE: 3,
};

export const TRAINING_FILTER_DEFAULT_VALUE = {
  ALL: {
    value: 'all',
    label: 'Show All Providers',
    translationKey: 'filters.showAllProviders',
  },
};

export const TRAINING_FILTER_FACULTY_DEFAULT_VALUE = {
  ALL: {
    value: 'all',
    label: 'Show All Faculties',
    translationKey: 'filters.showAllFaculties',
  },
};

export const EMPLOYEE_FILTER_STATUS = {
  ALL: {
    value: 'all',
    label: 'Show All',
    translationKey: 'filters.showAll',
  },
  ADDED: {
    value: 0,
    label: 'Added',
    translationKey: 'status.added',
  },
  INVITED: {
    value: 1,
    label: 'Invited',
    translationKey: 'status.invited',
  },
  ACTIVE: {
    value: 2,
    label: 'Active',
    translationKey: 'status.active',
  },
  INACTIVE: {
    value: 3,
    label: 'Inactive',
    translationKey: 'status.inactive',
  },
};

export const COURSE_RECURRENCE = {
  NONE: {
    index: 0,
    value: 0,
    label: 'recurrence.none',
    filterLabel: 'recurrence.none',
  },
  THREE_MONTHS: {
    index: 1,
    value: 1,
    label: 'recurrence.threeMonths',
    filterLabel: 'recurrence.threeMonths',
  },
  SIX_MONTHS: {
    index: 2,
    value: 2,
    label: 'recurrence.sixMonths',
    filterLabel: 'recurrence.sixMonths',
  },
  TWELVE_MONTHS: {
    index: 3,
    value: 3,
    label: 'recurrence.twelveMonths',
    filterLabel: 'recurrence.twelveMonths',
  },
  TWENTY_FOUR_MONTHS: {
    index: 4,
    value: 4,
    label: 'recurrence.twentyFourMonths',
    filterLabel: 'recurrence.twentyFourMonths',
  },
  THIRTY_SIX_MONTHS: {
    index: 5,
    value: 5,
    label: 'recurrence.thirtySixMonths',
    filterLabel: 'recurrence.thirtySixMonths',
  },
  FORTY_EIGHT_MONTHS: {
    index: 6,
    value: 6,
    label: 'recurrence.fortyEightMonths',
    filterLabel: 'recurrence.fortyEightMonths',
  },
  SIXTY_MONTHS: {
    index: 7,
    value: 7,
    label: 'recurrence.sixtyMonths',
    filterLabel: 'recurrence.sixtyMonths',
  },
};

export const TRAINING_ATTRIBUTE_DIALOG_TYPE = {
  DETAIL: 1,
  WARNING: 2,
};

export const TASK_ATTRIBUTE_DIALOG_TYPE = {
  COMPETENCIES: 1,
  REGULATIONS: 2,
  JOBS: 3,
};

export const CREATE_TASK_MODE = {
  CREATE: 1,
  EDIT: 2,
};
export const CREATE_PROVIDER_MODE = {
  CREATE: 1,
  EDIT: 2,
};
export const CREATE_TRAINING_MODE = {
  CREATE: 1,
  EDIT: 2,
};
export const REGULATION_ATTRIBUTE_TYPE = {
  REGION: 1,
  DOMAIN: 2,
  CATEGORY: 3,
  REGULATION: 4,
};

export const Feedback_filters = {
  all: { key: 'all', label: 'All', translationKey: 'requests.all' },
  pending: { label: 'Pending feedback', translationKey: 'requests.pendingFeedback' },
  submitted: { label: 'Feedback submitted', translationKey: 'requests.feedbackSubmitted' },
};

export const Dashboard_mode = {
  personal: {
    name: 'Personal',
    api: '/Dashboard',
    notificationsApi: '/Notifications',
  },
  team: {
    name: 'Team',
    api: '/Dashboard/Teams',
    notificationsApi: '/Notifications/Teams',
  },
  groups: {
    name: 'Groups',
    api: '/Dashboard/Groups',
    notificationsApi: '/Notifications/Group',
  },
};

export const Abstract_Attribute = {
  gapReason: {
    notSet: {
      label: 'notSet',
    },
    met: {
      label: 'met',
    },
    unmetMandatory: {
      label: 'unmetMandatory',
    },
    unmet: {
      label: 'unmet',
    },
  },
  status: {
    review: {
      index: 0,
      label: 'Under review',
      longLabel: 'Pending manager feedback',
      description: '',
      translationKey: 'status.underReview',
      longLabelTranslationKey: 'attributes.pendingManagerFeedback',
    },
    feedback: {
      index: 1,
      label: 'Needs feedback',
      longLabel: 'Needs employee feedback',
      description: '',
      translationKey: 'status.needsFeedback',
      longLabelTranslationKey: 'attributes.needsEmployeeFeedback',
    },
    approved: {
      index: 2,
      label: 'Approved',
      longLabel: 'Approved',
      description: '',
      translationKey: 'status.approved',
      longLabelTranslationKey: 'status.approved',
    },
    declined: {
      index: 3,
      label: 'Declined',
      longLabel: 'Declined',
      description: '',
      translationKey: 'status.declined',
      longLabelTranslationKey: 'status.declined',
    },
  },
  type: {
    mandatory: {
      index: 2,
      label: 'Compliance',
      filterLabel: 'Compliance',
      translationKey: 'labels.compliance',
    },
    required: {
      index: 1,
      label: 'Required',
      filterLabel: 'Required + Compliance',
      translationKey: 'labels.required',
    },
    desirable: {
      index: 0,
      label: 'Desirable',
      filterLabel: 'Desirable',
      translationKey: 'labels.desirable',
    },
  },
  compliance: {
    compliant: {
      label: 'Compliant',
    },
    nonCompliant: {
      label: 'Non-compliant',
    },
  },
};

export const Gap_Attribute = {
  reason: {
    ok: {
      label: 'OK',
      translationKey: 'status.ok',
    },
    lowProficiency: {
      label: 'Low proficiency',
      translationKey: 'status.lowProficiency',
    },
    missing: {
      label: 'Missing',
      translationKey: 'status.missing',
    },
  },
};

export const DOMAIN_BLANK = { id: null, name: '<Blank>' };
export enum IntegrationSource {
  LearnUpon = 1,
  HAS_API_Enrolments = 2,
  Manual = 3,
}

export const Allowed_Mime_Types = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];

export const Allowed_File_Extensions = [
  'png',
  'jpg',
  'jpeg',
  'pdf',
  'doc',
  'docx',
  'txt',
  'csv',
  'xlsx',
  'xls',
];
export const Max_File_Size = 10240000;
export const Error_Mime_Type =
  'Please upload a valid evidence file (doc, docx, pdf, txt, csv, xls, xlsx, png, jpg or jpeg).';
export const Error_File_Size = 'Please upload a valid evidence file (10Mb or less)';

export enum EmployeeTrainingStatus {
  Approved = 0,
  PendingApproval = 1,
  NeedsEmployeeFeedback = 2,
}
export const statusLabels = {
  [EmployeeTrainingStatus.Approved]: 'status.approved',
  [EmployeeTrainingStatus.PendingApproval]: 'status.underReview',
  [EmployeeTrainingStatus.NeedsEmployeeFeedback]: 'status.needsFeedback',
};

export enum ValidationRequestKind {
  EmployeeAttribute = 0,
  EmployeeTraining = 1,
}
export const Training_Dialog_Mode = {
  add: {
    title: 'Add training',
    key: 'add',
    translationKey: 'trainingDialog.addTraining',
  },
  edit: {
    title: 'Edit training',
    key: 'edit',
    translationKey: 'trainingDialog.editTraining',
  },
  requestChange: {
    title: 'Request changes',
    key: 'requestChange',
    translationKey: 'trainingDialog.requestChanges',
  },
  feedback: {
    title: 'Change training request',
    key: 'feedback',
    translationKey: 'trainingDialog.changeTrainingRequest',
  },
  details: {
    title: 'Training details',
    key: 'details',
    translationKey: 'trainingDialog.trainingDetails',
  },
};

export const EmployeeStatusMap = new Map([
  [EmployeeTrainingStatus.Approved, 'status.approved'],
  [EmployeeTrainingStatus.NeedsEmployeeFeedback, 'status.needsEmployeeFeedback'],
  [EmployeeTrainingStatus.PendingApproval, 'status.pendingManagerFeedback'],
]);

export const STANDARDS_LIBRARY_PAGING_TRIAL_MODEL = {
  Tasks: {
    maxRows: 15,
  },
  Competencies: {
    maxRows: 20,
  },
};

export enum UPLOAD_JOB_DESCRIPTION_STEP {
  UPLOAD_FILE = 1,
  INDUSTRY_STANDARD_MATCHES = 2,
}
export enum INDUSTRY_STANDARD_MATCHES_TAB {
  JOBS = 1,
  TASKS_AND_COMPETENCIES = 2,
}

export enum JOB_BENCHMARKING_TAB {
  JOB_DESCRIPTION = 1,
  TASKS = 2,
  COMPETENCIES = 3,
}

export enum PEOPLE_LIST_DIALOG_TYPE {
  PEOPLE = 'PEOPLE',
  GAPS = 'GAPS',
  HAVE = 'HAVE',
}

export enum CHECKLIST_QUESTION_TYPE {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  SHORT_ANSWER = 'SHORT_ANSWER',
  LONG_ANSWER = 'LONG_ANSWER',
  DATE = 'DATE_ANSWER',
  YES_NO = 'YES_NO',
  NUMERIC = 'NUMERIC',
}

export enum FILE_TYPE {
  PARTICIPANT = 'participant',
  PRACTICAL = 'practical',
}

export enum CHECKLIST_TYPE {
  PARTICIPANT = 'participant',
  PRACTICAL = 'practical',
}

export enum EmployeeAttributeValidationRequestType {
  NewAttribute,
  ProficiencyChange,
  AttributeDefinitionChange,
  AdminRequest,
  ExpiredAttribute,
  CompletedTraining,
  ParticipatedInPractical,
  InstructorRequest,
}

export enum TRAINING_MANAGER_PERMISSION {
  VIEW = '00000010-0000-0000-0000-000000000001',
  INVITE = '00000010-0000-0000-0000-000000000002',
  ENROLL = '00000010-0000-0000-0000-000000000004',
  UNENROLL = '00000010-0000-0000-0000-000000000007',
  CREATE_STUDENT = '00000010-0000-0000-0000-000000000008',
}

export enum CourseEnrolmentRequestStatus {
  Requested = 0,
  Approved = 1,
  Declined = 2,
  Cancelled = 3,
}

export enum FeedbackRequestType {
  CourseEnrollment = 0,
  Training = 1,
}

export enum LearningRequestStatus {
  Pending = 0,
  Approved = 1,
  Declined = 2,
  Cancelled = 3,
  NeedsFeedback = 4,
}
export const CEVENTAS_PROVIDER_ID = '00000012-0000-0000-0000-000000000001';

export const ENROLLMENT_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  PENDING_REVIEW: 'pending_review',
  PASSED: 'passed',
};

export const EMPLOYEE_FILTER_STATUS_OPTIONS = [
  { value: 'null', labelKey: 'common.all' },
  { value: '0', labelKey: 'status.added' },
  { value: '1', labelKey: 'status.invited' },
  { value: '2', labelKey: 'status.active' },
  { value: '3', labelKey: 'status.inactive' },
];

export const EMPLOYEE_FILTER_ACCESS_OPTIONS = [
  { value: 1, labelKey: 'accessLevel.full' },
  { value: 0, labelKey: 'accessLevel.limited' },
];

export const EMPLOYEE_FILTER_ROLE_OPTIONS = [
  { value: 0, labelKey: 'roles.admin' },
  { value: 1, labelKey: 'roles.billing' },
  { value: 2, labelKey: 'roles.instructor' },
  { value: 3, labelKey: 'roles.trainingManager' },
];

export enum PricingTab {
  Workforce = 'workforce',
  Careers = 'careers',
}

export enum COURSE_TYPE {
  DIPLOMA = 'Diploma',
  ONLINE_COURSE = 'Online Course',
  CERTIFICATE = 'Certificate',
  LEARNING_PATH = 'Learning Path',
}
